/* eslint-disable prettier/prettier */
import { Button, IconButton, Menu, MenuItem, Select } from '@material-ui/core';
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import Chat from '../chat';

import ChatIcon from '@material-ui/icons/Chat';
import GroupIcon from '@material-ui/icons/Forum';
import ContactsIcon from '@material-ui/icons/Contacts';
import LogoutIcon from '@material-ui/icons/ExitToApp';
import { NativeSelect } from '@material-ui/core';
import { Icon, InlineIcon } from '@iconify/react';
import squareEditOutline from '@iconify-icons/mdi/square-edit-outline';
import {
  FaUser,
  FaUsers,
  FaSignOutAlt,
  FaGlobe,
  FaArchive,
} from 'react-icons/fa';
import {
  Input,
  Content,
  ConversationsContainer,
  ConversationItem,
  Header,
  Profile,
  HeaderChat,
  ButtonsContainer,
  DateTimeMessage,
  Status,
  ContactContainer,
  Reads,
  ButtonsContainerMenu,
  SearchInput,
  ItensContainerMenu,
  ArchiveContainer,
  StatusForSSE,
  SearchArea
} from './styles';
import phoneImage from '../jitsi/molumen_phone_icon.png';
import { useConversation } from '../../hooks/conversation';
import { useAuth } from '../../hooks/auth';
import { useChatMessages } from '../../hooks/chat';
import ListContacts from '../../components/contacts';
import { useContacts } from '../../hooks/contacts';
import MenuSettings from '../../components/menuSettings';
import NewGroup from '../../components/newgroup';
import { convertBackendDate, getStringDate, truncateString } from '../../utils';
import MenuConversation from '../../components/menuConversation';
import Info from '../../components/info';
import { useGroups } from '../../hooks/groups';
import { useHistory } from 'react-router-dom';
import {
  getCallEvent,
  GetCallInformationUsingCallGuid,
  StartCallUsingContactInformation,
  GetOrCreateConversationByContactInformation,
} from '../../services/conversations';

import Groups from '../groups';

import ChangeLanguage from '../../components/ChangeLanguage';

import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import { useIntl } from 'react-intl';
import Swal from 'sweetalert2';

import ringer from './facebook_call.mp3';
import AccountSettings from '../../components/accountSettings';
import { REACT_APP_ENABLE_SERVERSENTEVENT, REACT_APP_VIEW_SSECONNECTIONSTATE } from '../../config';
import {  FaPlusSquare } from 'react-icons/fa';

const Conversations = () => {
  const { user, portal, setPortal, logout } = useAuth();

  const [anchorEl, setAnchorEl] = useState(null);
  const handleAccountClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleAccountClose = () => {
    setAnchorEl(null);
  };

  const [addAnchorEl, setAddanchorEl] = React.useState(null);
  
  const handleClick = (event) => {
    setAddanchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAddanchorEl(null);
  };

  // prettier-ignore
  const {
    conversations,
    archiveds,
    filterName,
    setFilterName,
    openInfo,
    setOpenInfo,
    reloadArchivedConversations,
    hasCall,
    setHasCall,
    isSSEConnectionActive,
  } = useConversation();
  const { reloadGroups, setMenuGroups,loadGroupsData, groups } = useGroups();
  const history = useHistory();
  const {
    conversation,
    setSelecetedConversation,
    setMessages,
    clearConversation,
    selectedPage,
    setSelectedPage,
    hasUpdate,
    setHasUpdate, //for SSE delete refresh
  } = useChatMessages();
  const [dataFiltered, setDataFiltered] = useState([]);
  const [archiveEffect, setArchiveEffect] = useState([]);
  const inputRef = useRef(null);
  const { setMenu } = useContacts();
  const intl = useIntl();
  const [callEvents, setCallEvents] = React.useState(null);
  const [ringerTune, setRingerTune] = React.useState(null);
  const [isIncomingCall, setIsIncomingCall] = React.useState(false);

  const audio = new Audio(ringer);
  // audio.loop = true;
  // check if any incoming call
  useEffect(() => {
    if(REACT_APP_ENABLE_SERVERSENTEVENT === 'false') {
      if (user && portal) {
        // const interval = setInterval(() => {
        const maxTimeOut = setTimeout(async () => {
          const data = await getCallEvent();
          Promise.resolve(data).then((data) => {
            if (data?.GetCallEventResult === true) {
              setIsIncomingCall(true);
              // set ringer
              setRingerTune(true);

              // play ringer
              audio.loop = true;
              audio.play();
              // console.log('ringer');
              // set call event
              setCallEvents(data?.callEvent);
              // set browser notification
              const notification = new Notification(
                'Call from ' + data?.callEvent?.ContactInformation?.Name,
                {
                  body: 'Do you want to accept the call?',
                }
              );

              notification.onclick = () => {
                history.push({
                  pathname: '/jitsi/' + data?.callEvent?.CallGuid,
                  state: callEvents,
                });
              };

              // confirm call
              Swal.fire({
                title: 'Call from ' + data?.callEvent?.ContactInformation?.Name,
                text: 'Do you want to accept the call?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
              }).then((result) => {
                if (result.value) {
                  audio.loop = false;
                  // redirect to call page
                  history.push({
                    pathname: '/jitsi/' + data?.callEvent?.CallGuid,
                    state: callEvents,
                  });
                } else {
                  audio.loop = false;
                  // set ringer
                  setRingerTune(false);
                  // play ringer
                  audio.pause();
                  //
                  const maxInterval = setInterval(() => {
                    setTimeout(() => {
                      getCallEventFromAPI();
                    }, 10000);
                  }, 15000);
                  if (isIncomingCall === true) {
                    return () => clearInterval(maxInterval);
                  }
                }
              });
            } else {
              const maxInterval = setInterval(() => {
                setTimeout(() => {
                  getCallEventFromAPI();
                }, 10000);
              }, 15000);
              if (isIncomingCall === true) {
                return () => clearInterval(maxInterval);
              }
            }
          });
        }, 10000);
        // }, 10000);
        return () => clearTimeout(maxTimeOut);
      }
    }
    else {
      if (user && portal) {
        const data = getCallEvent();
        Promise.resolve(data).then((data) => {
          if (data?.GetCallEventResult === true) {
            setIsIncomingCall(true);
            setRingerTune(true);
            audio.loop = true;
            audio.play();
            setCallEvents(data?.callEvent);
            // set browser notification
            const notification = new Notification(
              'Call from ' + data?.callEvent?.ContactInformation?.Name,
              {
                body: 'Do you want to accept the call?',
              }
            );

            notification.onclick = () => {
              history.push({
                pathname: '/jitsi/' + data?.callEvent?.CallGuid,
                state: callEvents,
              });
            };

            // confirm call
            Swal.fire({
              title: 'Call from ' + data?.callEvent?.ContactInformation?.Name,
              text: 'Do you want to accept the call?',
              icon: 'question',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
            }).then((result) => {
              if (result.value) {
                audio.loop = false;
                // redirect to call page
                history.push({
                  pathname: '/jitsi/' + data?.callEvent?.CallGuid,
                  state: callEvents,
                });
              } else {
                audio.loop = false;
                // set ringer
                setRingerTune(false);
                // play ringer
                audio.pause();
              }
            });
          }    
        })
      };
    }
  },[user, portal]);

   //This useeffect is same for both (SSE/without SSE) only hasCall added in parameter if SSE=True
  useEffect(() => {
    if(REACT_APP_ENABLE_SERVERSENTEVENT === 'true') {
      if (user && portal) {
        if (isIncomingCall === false) {
          //console.log(hasCall + ' oncall event from SSE');
          setTimeout(() => {
            getCallEventFromAPI();
          }, 10000);
        }
      }
    }
  }, [user, portal, isIncomingCall, hasCall]);

  // getCallEvent
  const getCallEventFromAPI = () => {
    const data = getCallEvent();
    Promise.resolve(data).then((data) => {
      if (data?.GetCallEventResult === true) {
        setIsIncomingCall(true);
        // set ringer
        setRingerTune(true);

        // play ringer
        audio.loop = true;
        audio.play();
        console.log('ringer');
        // set call event
        setCallEvents(data?.callEvent);
        // set browser notification
        const notification = new Notification(
          'Call from ' + data?.callEvent?.ContactInformation?.Name,
          {
            body: 'Do you want to accept the call?',
          }
        );

        notification.onclick = () => {
          history.push({
            pathname: '/jitsi/' + data?.callEvent?.CallGuid,
            state: callEvents,
          });
        };

        // confirm call
        Swal.fire({
          title: 'Call from ' + data?.callEvent?.ContactInformation?.Name,
          text: 'Do you want to accept the call?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
        }).then((result) => {
          if (result.value) {
            audio.loop = false;
            // redirect to call page
            history.push({
              pathname: '/jitsi/' + data?.callEvent?.CallGuid,
              state: callEvents,
            });
          } else {
            audio.loop = false;
            console.log('false');
          }
        });
      }
    });
  };

  // // end check if any incoming call
  // useEffect(() => {
  //   if(REACT_APP_ENABLE_SERVERSENTEVENT === 'false') {
  //   if (conversations) {
  //     // console.log(conversations[0]?.Owner.Name.toUpperCase());
  //     // console.log(conversations)
  //     setDataFiltered(
  //       conversations.filter((c) =>
  //         c.Owner.Name.toUpperCase().includes(filterName.toUpperCase())
  //       )
  //     );
  //     setSelectedPage(true);
  //   }
  //   // setInterval(() => {
  //   //   getCallEvent();
  //   // }, 5000);
  //   }
  // }, [conversations]);

  // //This useeffect is same as above has only change of filterName added in its parameter for SSE
  // useEffect(() => {
  //   if(REACT_APP_ENABLE_SERVERSENTEVENT === 'true') {
  //   if (conversations) {
  //     setDataFiltered(
  //       conversations.filter((c) =>
  //         c.Owner.Name.toUpperCase().includes(filterName.toUpperCase())
  //       )
  //     );
  //     setSelectedPage(true);
  //   }
  // }
  // }, [conversations,filterName]);

  const ensureGroupsInConversations = (groups = [], allConversations = []) => {
    const updatedConvos = [...allConversations];

    groups.forEach((group) => {
      const exists = updatedConvos.some(
        (conv) => conv?.Owner?.StaffGuid === group.GroupGuid
      );

      if (!exists) {
        updatedConvos.push({
          Administrator: group.Administrator,
          Broadcast: group.Broadcast,
          Guid: group.GroupGuid,
          Priority: group.Priority,
          IsGroupConversation: true,
          isGroup: true,
          isTemporaryGroup: true,
          Name: group.Name,
          Owner: {
            Name: group.Name,
            Number: group.GroupGuid,
            StaffGuid: group.GroupGuid,
          },

          LastMessage: null,
          NumberOfUnreadMessages: 0,
        });
      }
    });

    return updatedConvos;
  };

  useEffect(() => {
    if (!conversations) return;

    const merged = ensureGroupsInConversations(groups || [], conversations || []);

    setDataFiltered(
      merged.filter((c) =>
        c?.Owner?.Name?.toUpperCase().includes(filterName.toUpperCase())
      )
    );

    setSelectedPage(true);
  }, [groups, conversations, filterName]);

  useEffect(() => {
    if (conversations) {
      // console.log(conversations)

      setArchiveEffect(archiveds);
      setSelectedPage(true);
      if(REACT_APP_ENABLE_SERVERSENTEVENT === 'true') {
        // TODO: need to remove
        // setHasUpdate(hasUpdate == 0 ? 1 : 0);
      }
    }
  }, [conversations]);

  const onKeyUp = (event) => {
    setFilterName(inputRef.current?.value);
  };

  const handleClickContacts = (event) => {
    clearConversation('');
    setSelectedPage(false);
    if (openInfo) setOpenInfo(false);
    history.push('/contacts');
    if(REACT_APP_ENABLE_SERVERSENTEVENT === 'true'){
      loadGroupsData(true);
    }
  };

  const handleClickArchived = (event) => {
    clearConversation('');
    setSelectedPage(false);
    setOpenInfo(false);
    history.push('/archiveds');
  };

  const handleClickMessages = (event) => {
    history.push('/app');
  };

  const handleSelectTempGroupContact = async (groupItem) => {
    try {
      const response = await GetOrCreateConversationByContactInformation({
        contactInformation: {
          Name: groupItem.Name,
          Priority: groupItem.Priority,
          StaffGuid: groupItem.Guid,
        },
      });

      setSelecetedConversation({
        ...response.conversation,
        isGroup: response.IsGroupConversation,
      });

    } catch (error) {
      console.error('Error creating temp group conversation:', error);
    }
  };
  

  return (
    <>
      <Content>
        <Header>
          <ButtonsContainerMenu>
            {/* <ItensContainerMenu
              title={intl.formatMessage({
                id: 'Contacts',
              })}
            >
              <ContactsIcon onClick={handleClickContacts} />
            </ItensContainerMenu> */}
            <ItensContainerMenu
              title={intl.formatMessage({ id: 'Messages' })}
              isSelected={selectedPage}
            >
              <ChatIcon onClick={handleClickMessages} />
            </ItensContainerMenu>
            <ItensContainerMenu title={intl.formatMessage({ id: 'Logout' })}>
              <FaSignOutAlt size={22} onClick={logout} />
            </ItensContainerMenu>
          </ButtonsContainerMenu>
          {/* <Profile>{user}</Profile> */}
          {intl.formatMessage({ id: 'Messages' })}
          
          <ButtonsContainerMenu>
            <ItensContainerMenu
              title={intl.formatMessage({ id: 'NewMessage' })}
            >
              <Icon
                icon={squareEditOutline}
                width="24px"
                height="24px"
                onClick={async () => {
                  if (REACT_APP_ENABLE_SERVERSENTEVENT === 'false') {
                    await reloadGroups();
                  }
                  setMenu(true);
                }}
              />
            </ItensContainerMenu>
            {/* <ItensContainerMenu title={'Call History'}>
              <img
                src={phoneImage}
                alt=""
                style={{ height: '25px', cursor: 'pointer' }}
                onClick={() => history.push({ pathname: '/call/history' })}
              />
            </ItensContainerMenu> */}
            <ItensContainerMenu
              title={intl.formatMessage({ id: 'NewChartGroup' })}
            >
              <GroupIcon
                onClick={async () => {
                  setMenuGroups(true);
                }}
              />
            </ItensContainerMenu>
            <ItensContainerMenu title={intl.formatMessage({ id: 'Idioms' })}>
              <ChangeLanguage space="0rem" />
            </ItensContainerMenu>
            { REACT_APP_VIEW_SSECONNECTIONSTATE === 'true' &&
            <Profile>
              {isSSEConnectionActive ? <StatusForSSE status={1} /> : <StatusForSSE status={2} />}
            </Profile>
            }
            <ItensContainerMenu title={intl.formatMessage({ id: 'Account' })}>
              <AccountCircleOutlinedIcon onClick={handleAccountClick} />
              <AccountSettings
                anchorEl={anchorEl}
                handleClose={handleAccountClose}
              />
            </ItensContainerMenu>
          </ButtonsContainerMenu>
        </Header>
        {/* <SearchInput
          ref={inputRef}
          onKeyUp={onKeyUp}
          placeholder={intl.formatMessage({ id: 'SearchHere' })}
        /> */}
        <SearchArea>
          <SearchInput
            ref={inputRef}
            onKeyUp={onKeyUp}
            placeholder={intl.formatMessage({ id: 'SearchHere' })}
          />
          <FaPlusSquare
            color="#666666"
            onClick={handleClick}
          />
          <Menu
            id="simple-menu"
            anchorEl={addAnchorEl}
            keepMounted
            open={Boolean(addAnchorEl)}
            onClose={handleClose}
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            PaperProps={{
              style: {
                marginTop: '8px',
              },
            }}
          >
            <MenuItem
              onClick={async () => {
                if (REACT_APP_ENABLE_SERVERSENTEVENT === 'false') {
                  await reloadGroups();
                }
                setMenu(true);
                handleClose();
              }}
            >
              {intl.formatMessage({ id: 'NewChat' })}
            </MenuItem>
            <MenuItem
              onClick={async () => {
                setMenuGroups(true);
                handleClose();
              }}
            >
              {intl.formatMessage({ id: 'NewGroup' })}
            </MenuItem>
          </Menu>
        </SearchArea>
        <ConversationsContainer>
          {archiveEffect && archiveEffect.length > 0 && (
            <ConversationItem onClick={handleClickArchived}>
              <ArchiveContainer>
                <div style={{ display: 'flex', columnGap: 5 }}>
                  <FaArchive />
                  <span title={intl.formatMessage({ id: 'Archiveds' })}>
                    {truncateString(
                      intl.formatMessage({ id: 'Archiveds' }),
                      60
                    )}
                  </span>
                </div>
              </ArchiveContainer>
            </ConversationItem>
          )}
          {dataFiltered &&
            dataFiltered.length > 0 &&
            dataFiltered.map((c, key) => {
              let dateString = '';
              if (c.LastMessage) {
                dateString = convertBackendDate(c.LastMessage.MessageDateTime);
              }
              return (
                <ConversationItem
                  key={key}
                  onClick={() => {
                    if (c.isTemporaryGroup) {
                      handleSelectTempGroupContact(c);
                    } else {
                      setSelecetedConversation(c);
                      setMessages([]);
                    }
                  }}
                  isSelected={conversation && conversation.Guid === c.Guid}
                >
                  {c.NumberOfUnreadMessages !== 0 && (
                    <Reads>{c.NumberOfUnreadMessages}</Reads>
                  )}
                  <ContactContainer>
                    <div style={{ display: 'flex', columnGap: 5 }}>
                      {!c.isGroup && <FaUser />}
                      {c.isGroup && <FaUsers />}
                      <span title={c.Owner.Name}>
                        {truncateString(c.Owner.Name, 60)}
                      </span>
                    </div>
                    {c.isGroup && c.LastMessage && (
                      <h6
                        title={
                          c.LastMessage.ReferencedMessage &&
                          c.IsForward === true
                            ? c.LastMessage.ReferencedMessage.Message
                            : !c.LastMessage.IsPoll ? c.LastMessage.Message : 'Poll Message'
                        }
                      >
                        {truncateString(
                          `${c.LastMessage.Sender.Name}: ${
                            c.LastMessage.ReferencedMessage &&
                            c.IsForward === true
                              ? c.LastMessage.ReferencedMessage.Message
                              : !c.LastMessage.IsPoll ? c.LastMessage.Message : 'Poll Message'
                          }`,
                          60
                        )}
                      </h6>
                    )}
                    {!c.isGroup && c.LastMessage && (
                      <h6
                        title={
                          c.LastMessage.ReferencedMessage &&
                          c.LastMessage.IsForward === true
                            ? c.LastMessage.ReferencedMessage.Message
                            : !c.LastMessage.IsPoll ? c.LastMessage.Message : 'Poll Message'
                        }
                      >
                        {truncateString(
                          c.LastMessage.ReferencedMessage &&
                          c.LastMessage.IsForward === true &&
                          c.LastMessage.Message === intl.formatMessage({ id: 'ThisMessageHasBeenDeleted' }) 
                            ? c.LastMessage.Message
                            : c.LastMessage.ReferencedMessage?.Message
                              ? c.LastMessage.ReferencedMessage.Message
                              : !c.LastMessage.IsPoll
                                ? c.LastMessage.Message
                                : 'Poll Message',
                          60
                        )}
                      </h6>
                    )}
                  </ContactContainer>
                  <DateTimeMessage unreadLabel={c.NumberOfUnreadMessages !== 0}>
                    {getStringDate(dateString)}
                  </DateTimeMessage>
                </ConversationItem>
              );
            })}
        </ConversationsContainer>
        {conversation && (
          <React.Fragment>
            <HeaderChat>
              <div>
                <Profile>
                  {!conversation.isGroup && !conversation.Owner.Name && (
                    <Status status={conversation.Owner.OnlineState} />
                  )}
                  {conversation.Owner?.Name}
                </Profile>
              </div>
              <MenuConversation />
            </HeaderChat>
            <Chat conversationId={conversation} />
          </React.Fragment>
        )}
        <Info />
        <ListContacts clearFilterChats={() => setFilterName('')} />
        <NewGroup clearFilterChats={() => setFilterName('')} />
      </Content>
    </>
  );
};

export default Conversations;
